// extracted by mini-css-extract-plugin
export default {"root":"root__1ca94579","icon_wrap":"icon_wrap__1ca94579"};